import "./TalentCard.scss";
import { useEffect, useLayoutEffect, useRef, useState } from "react";
import { gsap, Flip } from "gsap/all";

function TalentCard(props) {
  gsap.registerPlugin(Flip);
  const cardEl = useRef();
  const q = gsap.utils.selector(cardEl);
  const [layoutState, setLayoutState] = useState();
  const [showDetail, setShowDetail] = useState(false);

  const clickHandler = () => {
    setLayoutState(Flip.getState(q(".talent_detail")));
    cardEl.current.classList.toggle("full-screen");
  };

  useLayoutEffect(() => {
    if (!layoutState) return;

    const flip = Flip.from(layoutState, {
      targets: q(".talent_detail"),
      // absolute: true,
      scale: true,
      fade: true,
      ease: "expo",
    });

    return () => {
      flip.kill();
    };
  }, [layoutState]);

  useEffect(() => {
    gsap.fromTo(
      cardEl.current,
      {
        opacity: 0,
      },
      {
        opacity: 1,
        scrollTrigger: {
          trigger: cardEl.current,
          toggleActions: "play none none reverse",
        },
      }
    );
  }, []);

  return (
    <div
      className="talent_card"
      onClick={clickHandler}
      onMouseEnter={() => setShowDetail(true)}
      ref={cardEl}
    >
      {showDetail ? (
        <div className="talent_detail">
          <div className="container mx-auto px-10 py-10">
            <img className="player" src={props.img} />
            <div className="col">
              <h3 className="mt-0">{props.name}</h3>
              <p>{props.sport}</p>
              <div className="flex flex-col md:flex-row md:items-center mt-5 md:mt-10">
                <svg
                  className="w-7 md:w-8 mr-10 md:mr-12 mb-2 md:mb-0"
                  viewBox="0 0 47 68"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M16.159 54.9139C6.15809 43.5381 1.11777 32.8612 1.11777 22.8528C1.11777 10.2319 11.3886 0 24.0589 0C36.7292 0 47 10.2312 47 22.8528C47 32.8879 41.9323 43.5958 31.8769 55.0069C40.7703 55.8698 47 58.1381 47 61.3116C47 65.4113 36.6039 68 23.5 68C10.3961 68 0 65.4113 0 61.3116C0 58.0162 6.71825 55.6966 16.1603 54.9137L16.159 54.9139ZM18.0609 57.0209C14.2297 57.2623 10.7402 57.756 7.94447 58.4521C6.00014 58.9358 4.46391 59.5022 3.44577 60.1018C2.595 60.6024 2.2368 61.0389 2.2368 61.3116C2.2368 61.5843 2.595 62.0207 3.44577 62.5214C4.4639 63.121 6.00014 63.6874 7.94447 64.1711C12.019 65.1858 17.5683 65.7706 23.4986 65.7706C29.4289 65.7706 34.9784 65.1858 39.0527 64.1711C40.997 63.6873 42.5333 63.121 43.5514 62.5214C44.4022 62.0207 44.7604 61.5843 44.7604 61.3116C44.7604 61.0389 44.4022 60.6024 43.5514 60.1018C42.5333 59.5021 40.997 58.9358 39.0527 58.4521C36.5154 57.8201 33.4056 57.3548 29.9879 57.0941C28.7355 58.4437 27.4151 59.8038 26.0259 61.1734C24.9358 62.2478 23.1803 62.2478 22.0903 61.1734C20.6759 59.779 19.3327 58.3949 18.0607 57.0209H18.0609ZM43.6417 22.8526C43.6417 12.0785 34.8741 3.34536 24.059 3.34536C13.2439 3.34536 4.47632 12.0792 4.47632 22.8526C4.47632 33.5207 10.9618 45.3882 24.059 58.4057C37.1563 45.3882 43.6417 33.521 43.6417 22.8526ZM24.059 32.3279C18.1875 32.3279 13.4281 27.5868 13.4281 21.7379C13.4281 15.889 18.1875 11.1479 24.059 11.1479C29.9305 11.1479 34.69 15.889 34.69 21.7379C34.69 27.5868 29.9305 32.3279 24.059 32.3279ZM24.059 28.9837C28.0761 28.9837 31.3328 25.7395 31.3328 21.7379C31.3328 17.7363 28.0761 14.4921 24.059 14.4921C20.042 14.4921 16.7852 17.7363 16.7852 21.7379C16.7852 25.7395 20.042 28.9837 24.059 28.9837Z"
                    fill="white"
                  />
                </svg>
                <span className="text-white md:text-lg">{props.location}</span>
              </div>
              <div className="flex flex-col md:flex-row md:items-start mt-5 md:mt-10 mb-10">
                <svg
                  className="w-8 md:w-10 mr-10 mt-2 mb-2 md:mb-0"
                  viewBox="0 0 64 70"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M38.3868 48.5487H34.5682L32.6216 44.657C32.2375 43.8914 30.9855 43.8914 30.602 44.657L28.657 48.5487H24.8384C24.3822 48.5487 23.9689 48.8229 23.795 49.2452C23.6201 49.6676 23.7169 50.153 24.04 50.4761L26.9755 53.4116L26.0022 57.3078C25.8948 57.7357 26.046 58.1863 26.3908 58.4615C26.736 58.7382 27.2093 58.7856 27.6025 58.59L31.6126 56.585L35.6242 58.59C35.7835 58.6707 35.9574 58.71 36.1287 58.71C36.3807 58.71 36.6302 58.6263 36.8354 58.4615C37.1797 58.1858 37.3298 57.7342 37.224 57.3077L36.2507 53.4116L39.1862 50.4761C39.5093 50.153 39.6061 49.6676 39.4312 49.2452C39.2563 48.8229 38.843 48.5487 38.3868 48.5487ZM34.2012 52.2664C33.921 52.5466 33.8071 52.9529 33.9044 53.338L34.4386 55.4731L32.1176 54.3138C31.9593 54.2331 31.7854 54.1938 31.6125 54.1938C31.4397 54.1938 31.2658 54.2331 31.108 54.3123L28.787 55.4715L29.3212 53.3364C29.4185 52.9514 29.3041 52.5451 29.0244 52.2649L27.5637 50.8067H29.3545C29.7825 50.8067 30.1731 50.5652 30.3651 50.1822L31.6126 47.6862L32.8601 50.1827C33.0522 50.5652 33.4428 50.8067 33.8707 50.8067H35.6615L34.2012 52.2664Z"
                    fill="white"
                  />
                  <path
                    d="M20.3225 51.9358H18.0645C18.0645 59.4065 24.1422 65.4842 31.6129 65.4842V63.2262C25.3876 63.2262 20.3225 58.1611 20.3225 51.9358Z"
                    fill="white"
                  />
                  <path
                    d="M31.6133 38.3873V40.6454C37.8386 40.6454 42.9037 45.7105 42.9037 51.9358H45.1617C45.1617 44.465 39.084 38.3873 31.6133 38.3873Z"
                    fill="white"
                  />
                  <path
                    d="M62.896 10.492L52.7346 0.330652C52.5235 0.119464 52.2387 0.0236955 51.9363 0.0191536V0H11.2909V0.0191536C10.9905 0.0226817 10.7047 0.118448 10.4925 0.330652L0.331184 10.492C-0.052895 10.8761 -0.109347 11.4764 0.195596 11.9259L18.7737 39.2473C15.5474 42.5115 13.5489 46.9938 13.5489 51.9354C13.5489 61.8956 21.6534 70 31.6135 70C41.5737 70 49.6781 61.8956 49.6781 51.9354C49.6781 46.9938 47.6797 42.5115 44.4528 39.2463L63.031 11.9249C63.3359 11.4768 63.2796 10.876 62.896 10.492ZM20.9268 13.5485H42.2998L31.6138 29.577L20.9268 13.5485ZM43.8043 11.2904H19.4209L13.3998 2.25814H49.8257L43.8043 11.2904ZM11.1151 2.90073L31.7668 33.8789C31.7149 33.8789 31.665 33.8709 31.6131 33.8709C27.4119 33.8709 23.5515 35.3251 20.4795 37.7389L2.58779 11.4278L11.1151 2.90073ZM31.6133 67.7423C22.897 67.7423 15.8067 60.6521 15.8067 51.9358C15.8067 43.2195 22.897 36.1293 31.6133 36.1293C40.3296 36.1293 47.4198 43.2195 47.4198 51.9358C47.4198 60.6521 40.3296 67.7423 31.6133 67.7423ZM42.7469 37.7396C40.4359 35.9231 37.6763 34.665 34.6606 34.1494L32.97 31.6136L52.1108 2.90124L60.6385 11.429L42.7469 37.7396Z"
                    fill="white"
                  />
                </svg>

                <ul className="text-white md:text-lg pl-5">
                  {props.medals.split(",").map((medal) => (
                    <li>{medal}</li>
                  ))}
                </ul>
              </div>

              <div className="">
                <p className="text-sm mt-0">SOCIAL</p>
                <div className="mt-5 flex social_icons">
                  {props.fb && (
                    <a target="_blank" href={props.fb}>
                      <svg
                        width="46"
                        height="46"
                        viewBox="0 0 56 56"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M27.9997 51.3333C40.242 51.3333 50.1663 41.409 50.1663 29.1667C50.1663 16.9244 40.242 7 27.9997 7C15.7574 7 5.83301 16.9244 5.83301 29.1667C5.83301 41.409 15.7574 51.3333 27.9997 51.3333Z"
                          fill="#DA1B22"
                        />
                        <path
                          d="M51.3332 28.142C51.3332 15.178 40.8855 4.66675 27.9998 4.66675C15.1142 4.66675 4.6665 15.178 4.6665 28.142C4.6665 39.8582 13.1979 49.5705 24.3543 51.3334V34.9294H18.4283V28.142H24.3543V22.969C24.3543 17.0861 27.8391 13.8344 33.1679 13.8344C35.7207 13.8344 38.3917 14.2932 38.3917 14.2932V20.0704H35.4484C32.551 20.0704 31.6454 21.8795 31.6454 23.7382V28.142H38.1161L37.0825 34.9294H31.6454V51.3334C42.8018 49.5738 51.3332 39.8615 51.3332 28.142Z"
                          fill="white"
                        />
                      </svg>
                    </a>
                  )}

                  {props.tw && (
                    <a target="_blank" href={props.tw}>
                      <svg
                        width="46"
                        height="46"
                        viewBox="0 0 56 57"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M27.9998 52.25C40.8865 52.25 51.3332 41.6168 51.3332 28.5C51.3332 15.3832 40.8865 4.75 27.9998 4.75C15.1132 4.75 4.6665 15.3832 4.6665 28.5C4.6665 41.6168 15.1132 52.25 27.9998 52.25Z"
                          fill="white"
                        />
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M41.9997 21.4591C41.1078 21.932 40.0177 22.2157 39.0267 22.3103C40.1168 21.6482 40.9096 20.6079 41.306 19.3783C40.315 19.9458 39.2249 20.4187 37.9366 20.7024C36.9456 19.6621 35.6573 19 34.1708 19C31.297 19 28.9186 21.3645 28.9186 24.391C28.9186 24.7694 28.9186 25.2423 29.0177 25.6206C24.6573 25.4314 20.7925 23.2561 18.2159 20.0404C17.7204 20.797 17.5222 21.7428 17.5222 22.7832C17.5222 24.6748 18.4141 26.2826 19.8015 27.2284C18.9096 27.2284 18.1168 26.9447 17.4231 26.5664V26.661C17.4231 29.2146 19.2069 31.3899 21.5853 31.9574C21.1889 32.052 20.6934 32.1466 20.1979 32.1466C19.9006 32.1466 19.5042 32.1466 19.2069 32.052C19.9006 34.2273 21.7835 35.7406 24.0627 35.7406C22.279 37.1593 19.9997 38.0105 17.6213 38.0105C17.2249 38.0105 16.8285 38.0105 16.333 37.9159C18.6123 39.4292 21.3871 40.375 24.36 40.375C33.9726 40.375 39.2249 32.2411 39.2249 25.1477C39.2249 24.9585 39.2249 24.6748 39.2249 24.4856C40.4141 23.5398 41.306 22.594 41.9997 21.4591Z"
                          fill="#DA1B22"
                        />
                      </svg>
                    </a>
                  )}

                  {props.yt && (
                    <a target="_blank" href={props.yt}>
                      <svg
                        width="46"
                        height="46"
                        viewBox="0 0 56 56"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M27.9998 51.3334C40.8865 51.3334 51.3332 40.8867 51.3332 28.0001C51.3332 15.1134 40.8865 4.66675 27.9998 4.66675C15.1132 4.66675 4.6665 15.1134 4.6665 28.0001C4.6665 40.8867 15.1132 51.3334 27.9998 51.3334Z"
                          fill="white"
                        />
                        <path
                          d="M42.3121 20.6768C41.9777 19.4321 40.9931 18.4475 39.7484 18.1131C37.5005 17.5 28.4533 17.5 28.4533 17.5C28.4533 17.5 19.4061 17.5186 17.1582 18.1316C15.9135 18.466 14.9289 19.4506 14.5945 20.6953C14 22.9432 14 27.6433 14 27.6433C14 27.6433 14 32.3434 14.6131 34.6099C14.9475 35.8546 15.9321 36.8392 17.1768 37.1736C19.4246 37.7866 28.4719 37.7866 28.4719 37.7866C28.4719 37.7866 37.5191 37.7866 39.767 37.1736C41.0117 36.8392 41.9963 35.8546 42.3307 34.6099C42.9437 32.362 42.9437 27.6433 42.9437 27.6433C42.9437 27.6433 42.9252 22.9432 42.3121 20.6768Z"
                          fill="#DA1B22"
                        />
                        <path
                          d="M25.5737 31.9904L33.079 27.6433L25.5737 23.2961V31.9904Z"
                          fill="white"
                        />
                      </svg>
                    </a>
                  )}

                  {props.insta && (
                    <a target="_blank" href={props.insta}>
                      <svg
                        width="46"
                        height="46"
                        viewBox="0 0 56 56"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M27.9998 51.3334C40.8865 51.3334 51.3332 40.8867 51.3332 28.0001C51.3332 15.1134 40.8865 4.66675 27.9998 4.66675C15.1132 4.66675 4.6665 15.1134 4.6665 28.0001C4.6665 40.8867 15.1132 51.3334 27.9998 51.3334Z"
                          fill="white"
                        />
                        <path
                          d="M40.756 22.709C40.6936 21.3429 40.4766 20.4101 40.1593 19.5939C39.8372 18.7375 39.332 17.9619 38.6791 17.3208C38.0382 16.6679 37.2624 16.1625 36.406 15.8402C35.5897 15.5231 34.657 15.3064 33.2909 15.2443C31.9223 15.1816 31.4851 15.1667 27.9998 15.1667C24.5146 15.1667 24.0773 15.1816 22.7088 15.2439C21.3427 15.3064 20.41 15.5233 19.5936 15.8406C18.7373 16.1627 17.9617 16.6679 17.3205 17.3208C16.6677 17.9617 16.1623 18.7374 15.8399 19.5937C15.5229 20.4101 15.3061 21.3429 15.244 22.7088C15.1814 24.0776 15.1665 24.5147 15.1665 27.9999C15.1665 31.4853 15.1814 31.9226 15.244 33.2912C15.3063 34.657 15.5233 35.5899 15.8405 36.4063C16.1626 37.2624 16.6679 38.0383 17.3207 38.6792C17.9617 39.3321 18.7375 39.8373 19.5938 40.1594C20.41 40.4768 21.3429 40.6936 22.7089 40.7561C24.0777 40.8185 24.5148 40.8332 28 40.8332C31.4853 40.8332 31.9225 40.8185 33.2911 40.7561C34.6572 40.6936 35.5899 40.4768 36.4062 40.1594C38.1301 39.4928 39.4928 38.1301 40.1593 36.4063C40.4768 35.5899 40.6936 34.657 40.756 33.2912C40.8183 31.9224 40.8332 31.4853 40.8332 28.0001C40.8332 24.5147 40.8183 24.0776 40.756 22.709ZM38.4459 33.186C38.3889 34.4373 38.1798 35.1168 38.0041 35.569C37.5724 36.6883 36.6878 37.5728 35.5685 38.0046C35.1164 38.1802 34.4369 38.3894 33.1856 38.4464C31.8326 38.5082 31.4267 38.5212 27.9998 38.5212C24.5728 38.5212 24.167 38.5082 22.8139 38.4464C21.5628 38.3894 20.8833 38.1802 20.431 38.0046C19.8737 37.7988 19.3694 37.4708 18.9554 37.0445C18.5291 36.6305 18.2011 36.1265 17.9953 35.569C17.8197 35.1168 17.6105 34.4373 17.5536 33.186C17.4919 31.8329 17.4788 31.427 17.4788 28.0003C17.4788 24.5734 17.4919 24.1677 17.5536 22.8143C17.6107 21.563 17.8197 20.8835 17.9953 20.4314C18.2011 19.8739 18.5293 19.3697 18.9554 18.9557C19.3694 18.5294 19.8737 18.2014 20.4312 17.9958C20.8833 17.8199 21.5628 17.611 22.8141 17.5538C24.1672 17.4921 24.5732 17.479 27.9998 17.479H27.9996C31.4263 17.479 31.8323 17.4921 33.1856 17.554C34.4369 17.611 35.1162 17.8201 35.5685 17.9958C36.1258 18.2016 36.6301 18.5296 37.044 18.9557C37.4703 19.3697 37.7983 19.8739 38.0039 20.4314C38.1798 20.8835 38.3889 21.563 38.4459 22.8143C38.5076 24.1675 38.5207 24.5734 38.5207 28.0001C38.5207 31.427 38.5078 31.8327 38.4459 33.186Z"
                          fill="#DA1B22"
                        />
                        <path
                          d="M27.9996 21.4099C24.3601 21.4099 21.4097 24.3605 21.4097 28.0001C21.4097 31.6396 24.3601 34.59 27.9996 34.59C31.6394 34.59 34.5898 31.6396 34.5898 28.0001C34.5898 24.3605 31.6394 21.4099 27.9996 21.4099ZM27.9996 32.2778C25.6373 32.2776 23.7219 30.3625 23.7221 27.9999C23.7221 25.6375 25.6373 23.7222 27.9998 23.7222C30.3624 23.7224 32.2775 25.6375 32.2775 27.9999C32.2775 30.3625 30.3622 32.2778 27.9996 32.2778Z"
                          fill="#DA1B22"
                        />
                        <path
                          d="M36.3901 21.1498C36.3901 22.0002 35.7006 22.6897 34.8502 22.6897C33.9995 22.6897 33.3101 22.0002 33.3101 21.1498C33.3101 20.2991 33.9995 19.6096 34.8502 19.6096C35.7006 19.6096 36.3901 20.2991 36.3901 21.1498Z"
                          fill="#DA1B22"
                        />
                      </svg>
                    </a>
                  )}
                </div>
              </div>
            </div>
            <svg
              className="back"
              clip-rule="evenodd"
              fill-rule="evenodd"
              stroke-linejoin="round"
              stroke-miterlimit="2"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="m12 10.93 5.719-5.72c.146-.146.339-.219.531-.219.404 0 .75.324.75.749 0 .193-.073.385-.219.532l-5.72 5.719 5.719 5.719c.147.147.22.339.22.531 0 .427-.349.75-.75.75-.192 0-.385-.073-.531-.219l-5.719-5.719-5.719 5.719c-.146.146-.339.219-.531.219-.401 0-.75-.323-.75-.75 0-.192.073-.384.22-.531l5.719-5.719-5.72-5.719c-.146-.147-.219-.339-.219-.532 0-.425.346-.749.75-.749.192 0 .385.073.531.219z" />
            </svg>
          </div>
        </div>
      ) : null}
      <img className="thumb" src={props.img} alt="" />
      <div className="l1"></div>
      <div className="l2 p-5">
        <h3>{props.name}</h3>
        <p>{props.sport}</p>
      </div>
      <div className="curtain"></div>
    </div>
  );
}

export default TalentCard;
